export const CONFIG = {
  LS_APIM_URL: process.env.REACT_APP_LS_APIM_URL,
  IDAM_APIM_URL: process.env.REACT_APP_IDAM_APIM_URL,
  NSE_URL: process.env.REACT_APP_NSE_URL,
  ASSET_URL: process.env.REACT_APP_ASSET_URL,
  TERRITORY_KEY: process.env.REACT_APP_TERRITORY_KEY,
  CONTRACT_API_URL: process.env.REACT_APP_CONTRACT_API_URL,
  PROSPECT_API_URL: process.env.REACT_APP_PROSPECT_API_URL,
  IDAM_TOKEN_API_URL: process.env.REACT_APP_IDAM_TOKEN_API_URL,
  CLIENT_ID: process.env.REACT_APP_CLIENT_ID,
  CLIENT_SECRET: process.env.REACT_APP_CLIENT_SECRET,
  GROWTH_BOOK_API_HOST: process.env.REACT_APP_GROWTH_BOOK_API_HOST,
  GROWTH_BOOK_CLIENT_KEY: process.env.REACT_APP_GROWTH_BOOK_CLIENT_KEY,
  MICROSOFT_CLARITY_IS_ENABLED: process.env.REACT_APP_MICROSOFT_CLARITY_IS_ENABLED,
  MICROSOFT_CLARITY_TRACING_ID: process.env.REACT_APP_MICROSOFT_CLARITY_TRACING_ID,
  ENV_NAME: process.env.REACT_APP_ENV_NAME || 'development',
};
